import fs from 'fs'

export default () =>
  new Promise((resolve, reject) => {
    const { readFile = null } = fs

    if (readFile === null) {
      resolve({})
      return
    }

    readFile('package.json', (err, packageJson) => {
      if (err) {
        reject(err)
        return
      }

      const packageJsonObj = JSON.parse(packageJson.toString())

      const { name, version } = packageJsonObj

      resolve({
        name,
        version,
      })
    })
  })
